import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/tenant/privacy/tenant.privacy.reset.mutation.gql"
import type {
  TenantPrivacyResetMutation,
  TenantPrivacyResetMutationVariables,
} from "@/v2-backoffice-client/tenant/privacy/__types__/tenant.privacy.reset.mutation"

type Options = MutationHookOptions<
  TenantPrivacyResetMutation,
  TenantPrivacyResetMutationVariables
>

export function useTenantPrivacyResetMutation(options?: Options) {
  return useMutation<
    TenantPrivacyResetMutation,
    TenantPrivacyResetMutationVariables
  >(mutation, options)
}
